import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthHttpService } from "../../users";
import { getApiPath } from "../../common";

/** Machine-readable `reason` codes of init-onfido-verification 400 bodies (TAX-3410). */
export enum IdentityRefusalReason {
  Verified = "verified",
  RedFinal = "red_final",
  BlockedElsewhere = "blocked_elsewhere",
  Pending = "pending",
  TokenFailed = "token_failed"
}

export interface InitOnfidoVerificationResponse {
  onfido_token: string;
}

export interface ResetIdentityVerificationResponse {
  ok: boolean;
}

export interface IdentityRefusalResponse {
  error: string;
  reason: IdentityRefusalReason;
  resets_remaining: number | null;
  statement_id: number | null;
}

@Injectable()
export class IdentityVerificationService {
  constructor(private authHttp: AuthHttpService) {}

  initOnfidoVerification(statementId: number): Observable<InitOnfidoVerificationResponse> {
    return this.authHttp.get<InitOnfidoVerificationResponse>(
      `${getApiPath()}statements/${statementId}/init-onfido-verification/`
    );
  }

  checkOnfidoVerification(statementId: number): Observable<any> {
    return this.authHttp.get(
      `${getApiPath()}statements/${statementId}/check-onfido-verification/`
    );
  }

  resetIdentityVerification(statementId: number): Observable<ResetIdentityVerificationResponse> {
    return this.authHttp.post<ResetIdentityVerificationResponse>(
      `${getApiPath()}statements/${statementId}/reset-identity-verification/`,
      {}
    );
  }
}
